import {FormInstance} from 'antd/es/form';
import {createContext} from 'react';

import {IValidationController} from 'components/editable-table/model/types';
import {TStateSetter} from 'shared/types/generics';

export type TFormsFileModal = {
    form?: FormInstance;
    setForm?: TStateSetter<FormInstance | undefined>;
    validation?: IValidationController;
    setValidation?: TStateSetter<IValidationController | undefined>;
}

const FormsFileModalInitState = {
    form: undefined,
    setForm: undefined,
    validation: undefined,
    setValidation: undefined,
};

export const FormsFileModalContext = createContext<TFormsFileModal>(FormsFileModalInitState);
